import React from 'react';

// @material-ui/core components

// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';

import { Formik, FormikProps } from 'formik';
import CardWrapper from '@components/Card/CardWrapper';
import { AdminRegisterServicerInput,  UpdateServicerInput } from '../../types/clientServiceGlobalTypes';
import EditItemForm from './ServicerForm/EditItemForm';

interface IRTable {
  handleSubmit: (payload: UpdateServicerInput) => void;
  isLoading: boolean;
  item: UpdateServicerInput;
}

const EditItem: React.FC<IRTable> = ({ handleSubmit, isLoading, item }) => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          <Formik
            onSubmit={async (values: any) => handleSubmit(values)}
            initialValues={{
              ...item,
            }}
        //     validationSchema={updateServicerValidationSchema}
            validateOnChange={true}
          >
            {(formBag) => (
              <EditItemForm
                formBag={(formBag as unknown) as FormikProps<AdminRegisterServicerInput>}
                disableLoginButton={isLoading}
              />
            )}
          </Formik>
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default EditItem;
